import { t } from 'i18next';

import { signOut } from 'authOld/services/auth';
import { IAuthUser } from 'authOld/types';
import { AccessPermissions, VersionType } from 'core/enums';
import { VersionTypeHelper } from 'core/helpers';
import { HeaderModalOptions } from 'coreOld/constants';
import { Icon } from 'coreOld/elements';
import { INavItem } from 'coreOld/types';
import { goTo } from 'coreOld/utils';
import {
  oldCompanySettingsPath,
  oldOldHomePath,
  oldReportsPath,
  oldUserProfilePath,
} from 'profile/routes/routePaths';
import { systemSettingsPath } from 'system/routes/routePaths';

import { navStructure } from '../Navigation/navStructure';
import {
  navBrowseStructure,
  navCompanyStructure,
  navPricingProfileStructure,
  navUsersStructure,
} from '../RightNavigation/navStructure';

export const navProfileStructure = (
  openAuthModal: (type: HeaderModalOptions) => void,
  user?: IAuthUser,
  collapsedMenu = false,
  onUserVersionChange?: (user: IAuthUser) => void
): INavItem[] => {
  const userVersionType = VersionTypeHelper.determineVersionTypeByUser(user as any);
  const changeToVersionType =
    userVersionType === VersionType.ALTERNATE ? VersionType.LEGACY : VersionType.ALTERNATE;

  return [
    {
      name: t('labelMyProfile'),
      onClick: () => goTo(oldUserProfilePath()),
      icon: user?.impersonated ? <Icon name={Icon.IMPERSONATED_USER} /> : null,
    },
    {
      name: t('labelCompanySettings'),
      onClick: () => goTo(oldCompanySettingsPath()),
      hide: !user?.companyAdmin,
      permissions: [AccessPermissions.COMPANY_SETTINGS],
    },
    {
      name: t('labelSystemSettings'),
      url: systemSettingsPath(),
      hide: !user?.admin,
      permissions: [AccessPermissions.SYSTEM_SETTINGS],
    },
    {
      name: t('labelReports'),
      onClick: () => goTo(oldReportsPath()),
    },
    {
      name: t('labelHomeOld'),
      onClick: () => goTo(oldOldHomePath()),
      hide: !user?.admin,
    },
    ...navStructure(Boolean(user), openAuthModal, collapsedMenu, false),
    ...navBrowseStructure(!collapsedMenu),
    ...navUsersStructure(!collapsedMenu),
    ...navCompanyStructure(!collapsedMenu),
    ...navPricingProfileStructure(!collapsedMenu),
    {
      name: t('labelSwitchUsers'),
      hide: !(user?.admin || user?.impersonated),
      onClick: () => openAuthModal(HeaderModalOptions.SWITCH_USERS),
    },
    {
      name: t('labelSwitchUserVersionType', {
        versionType: VersionTypeHelper.getVersionTypeLabel(changeToVersionType),
      }),
      permissions: [AccessPermissions.SWITCH_USER_VERSION],
      onClick: () => onUserVersionChange(user),
    },
    {
      name: t('labelSignOut'),
      onClick: () => signOut(),
    },
  ];
};
